import { render, staticRenderFns } from "./BrandTest.vue?vue&type=template&id=2b340578&scoped=true&"
import script from "./BrandTest.vue?vue&type=script&lang=js&"
export * from "./BrandTest.vue?vue&type=script&lang=js&"
import style0 from "./BrandTest.vue?vue&type=style&index=0&id=2b340578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b340578",
  null
  
)

export default component.exports